module.exports = __webpack_public_path__ + "assets/advantages-delivery-0fc0b0.svg";